import { readUsergroupActions } from '../../constants';

export const fetchUserGroups = (category, page, pageSize, append) => ({
  type: readUsergroupActions.FETCH_USERGROUPS,
  category,
  page,
  pageSize,
  append,
});

export const fetchUserGroupsMetrics = (category, page, pageSize) => ({
  type: readUsergroupActions.FETCH_USERGROUPS_METRICS,
  category,
  page,
  pageSize,
});

export const showUserGroups = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: readUsergroupActions.SHOW_USERGROUPS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showUserGroupsMetrics = (category, results) => ({
  type: readUsergroupActions.SHOW_USERGROUPS_METRICS,
  category,
  results,
});

export const showUserGroupsError = (category, error) => ({
  type: readUsergroupActions.SHOW_USERGROUPS_ERROR,
  category,
  error,
});

export const showUserGroupsMetricsError = (category, error) => ({
  type: readUsergroupActions.SHOW_USERGROUPS_METRICS_ERROR,
  category,
  error,
});

export const toggleUserGroupSelected = (category, code) => ({
  type: readUsergroupActions.TOGGLE_USERGROUP_SELECTED,
  category,
  code,
});

export const toggleUserGroupsSelected = (category, selected) => ({
  type: readUsergroupActions.TOGGLE_USERGROUPS_SELECTED,
  category,
  selected,
});

export const fetchUserGroup = (category, code, isNew) => ({
  type: readUsergroupActions.FETCH_USERGROUP,
  category,
  code,
  isNew,
});

export const showUserGroup = (category, code, result, isNew) => ({
  type: readUsergroupActions.SHOW_USERGROUP,
  category,
  code,
  result,
  isNew,
});

export const showUserGroupError = (category, code, error) => ({
  type: readUsergroupActions.SHOW_USERGROUP_ERROR,
  category,
  code,
  error,
});

export const closeUserGroup = ({ category, code }) => ({
  type: readUsergroupActions.CLOSE_USERGROUP,
  category,
  code,
});

export const closeUserGroups = ({ category }) => ({
  type: readUsergroupActions.CLOSE_USERGROUPS,
  category,
});

export const toggleUserGroupsPresentation = (category, display) => ({
  type: readUsergroupActions.TOGGLE_USERGROUPS_PRESENTATION,
  category,
  display,
});

export const updateUsergroupPanels = (category, code, index) => ({
  type: readUsergroupActions.UPDATE_USERGROUP_PANELS,
  category,
  code,
  index,
});

export const updateUserGroupsFilter = (category, value) => ({
  type: readUsergroupActions.UPDATE_USERGROUPS_FILTER,
  category,
  value,
});

export const updateUsergroupSearchFilter = (category, code, filter) => ({
  type: readUsergroupActions.UPDATE_USERGROUP_USERS_SEARCH_FILTER,
  category,
  code,
  filter,
});

export const fetchUsergroupSearchUsers = (category, code, filter) => ({
  type: readUsergroupActions.FETCH_USERGROUP_USERS_SEARCH,
  category,
  code,
  filter,
});

export const showUsergroupSearchUsers = (category, code, results) => ({
  type: readUsergroupActions.SHOW_USERGROUP_USERS_SEARCH,
  category,
  code,
  results,
});

export const showUsergroupSearchUsersError = (category, code, error) => ({
  type: readUsergroupActions.SHOW_USERGROUP_USERS_SEARCH_ERROR,
  category,
  code,
  error,
});

export const showClonedUserGroup = (category, code, response, items) => ({
  type: readUsergroupActions.SHOW_CLONED_USERGROUP,
  category,
  code,
  response,
  items,
});
